module.exports = "/_next/static/resources/photo-1-5b61d23721d98c1dbe6c71d3a0b01bff.jpg";